import React, { ReactNode, forwardRef } from "react";
import { DatePickerProps } from "antd";
import CalendarIcon from "core/icons/calendar/calendar.svg?react";
import { Container, Date, Label, ErrorMessage, Range } from "./_datePickerStyle";

type Props = DatePickerProps & {
  label?: string | ReactNode;
  name?: string;
  placeholder?: string;
  value?: any;
  setFieldValue?: (...args: any[]) => any;
  onChange?: (...args: any[]) => any;
  dateFormat?: string;
  prefixIcon?: React.ReactNode;
  errorPosition?: string;
  error?: string;
  type?: "date" | "range";
  disabled?: boolean;
  "data-testid"?: string;
};

const DatePicker = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const {
    label,
    name,
    disabledDate,
    setFieldValue,
    disabled,
    dateFormat,
    error,
    errorPosition,
    prefixIcon,
    type,
    "data-testid": dataTestId,
    ...rest
  } = props;

  const handleChangeDate = (dateString: any) => {
    setFieldValue?.(props.name, dateString);
  };

  const DatePicker = type === "date" ? Date : Range;

  return (
    // @ts-expect-error TS(2769): No overload matches this call.
    <Container disabled={disabled} data-testid={dataTestId}>
      <Label>{label}</Label>
      {/* @ts-expect-error TS(2604): JSX element type 'DatePicker' does not have any co... Remove this comment to see the full error message */}
      <DatePicker
        name={name}
        format={dateFormat}
        disabledDate={disabledDate}
        onChange={handleChangeDate}
        disabled={disabled}
        error={error}
        suffixIcon={prefixIcon}
        className="date-picker-component"
        ref={ref}
        {...rest}
      />
      {error && (
        <ErrorMessage errorPosition={errorPosition} data-testid={`${dataTestId}-error-message`}>
          {error}
        </ErrorMessage>
      )}
    </Container>
  );
});

DatePicker.defaultProps = {
  name: "",
  disabledDate: () => false,
  setFieldValue: () => {},
  onChange: () => {},
  dateFormat: "DD-MMM-YYYY",
  prefixIcon: <CalendarIcon />,
  errorPosition: "",
  error: "",
  type: "date",
};

export default DatePicker;
